import React from 'react';
import { View, Image, StyleSheet } from '@react-pdf/renderer';
const styles = StyleSheet.create({
    image: {
        width: '100%',
        height: '100%',
        alignSelf: 'center',
        objectFit: 'cover',
        objectPosition: 'center',
    },
});
const CardItemImage = ({ id, imageSrc }) => {
    if (!imageSrc) {
        return null;
    }
    return (React.createElement(View, { style: { flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80px' } },
        React.createElement(Image, { src: id === 'interior' ? imageSrc : `https://corsproxy.io/?url=${encodeURIComponent(imageSrc)}`, style: styles.image })));
};
export default CardItemImage;
